module.exports = __webpack_public_path__ + "static/media/Caesar.4528a133.jpg";